import React from 'react';
import { DialogContentText } from '@mui/material';

import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { removeBundleFromTruckload } from '../../../actions/truckloadActions';
import { useAppDispatch, useAppSelector } from '../../hooks';

export interface ConfirmRemoveBundleFromTruckloadDialogProps {
  readonly bundleGuid: string;
}

export function ConfirmRemoveBundleFromTruckloadDialog(props: ConfirmRemoveBundleFromTruckloadDialogProps) {
  const { bundleGuid } = props;
  const dispatch = useAppDispatch();
  const bundles = useAppSelector((state) => state.bundles);
  const truckloads = useAppSelector((state) => state.truckloads);
  const bundle = bundles[bundleGuid];

  return (
    <Dialog
      title="Confirm Remove"
      open
      submitText="Remove"
      onSubmit={() => {
        dispatch(removeBundleFromTruckload(bundleGuid));
        dispatch(closeCurrentPopup());
      }}
      onCancel={() => void dispatch(closeCurrentPopup())}
      contentSx={{ width: '400px', height: '50px' }}
      enterKeySubmits
    >
      <DialogContentText>
        {`Remove bundle ${bundle.id} from truckload ${truckloads[bundle.truckloadGuid!].id}?`}
      </DialogContentText>
    </Dialog>
  );
}
